<template>
<div v-if="dimensionsMode === 'l'" class="odr-waitlist-dialog" :style="`width: ${width}px !important;`">
    <form v-if="showSetting" class="odr-form" @submit="submitSetting">
        <gap all="double" block="true">
            <gap all="double" block="true">
                <gap block="true">
                    <row table="true">
                        <column>
                            <align-center textAlign="center">
                                {{ $trl('aw.waitlist_description') }}
                            </align-center>
                        </column>
                    </row>
                    <br>
                    <row>
                        <column>
                            <align-center textAlign="center">
                                <text-regular bold="true">Note: </text-regular>
                                {{ $trl('aw.waitlist_note') }}
                            </align-center>
                        </column>
                    </row>
                </gap>
            </gap>
            <gap top="double" block="true">
                <row table="true">
                    <column>
                        <align-opposite>
                            <text-regular bold="true">
                                {{ providerConfiguration.title }}
                            </text-regular>
                        </align-opposite>
                    </column>
                    <column>
                        <block :id="providerConfiguration.id"
                               stateId="stateId"
                               :value="providerConfiguration.value"
                               :values="providerConfiguration.options"
                               :type="providerConfiguration.type"
                               :title="providerConfiguration.title"
                               :settings="providerConfiguration.settings"
                               :suggest="providerConfiguration.settings.suggest"
                               :data-qa="providerConfiguration.dataQa"
                               @input="(value) => onProviderChanged(value)"/>
                    </column>
                </row>
                <row table="true">
                    <column/>
                    <column>
                        <div v-if="optionErrorMessages && optionErrorMessages.get(providerConfiguration.id)"
                             :id="providerConfiguration.id"
                             :data-qa="`${id}.error`"
                             class="odr-error-message"
                             :class="{
                                 'odr-error-message_plain': $root.appConfig.mode !== 'chat'
                             }">
                            {{ optionErrorMessages.get(providerConfiguration.id) }}
                        </div>
                    </column>
                </row>
            </gap>
            <gap top="double" block="true">
                <row table="true">
                    <column>
                        <align-opposite>
                            <text-regular bold="true">
                                {{ methodConfiguration.title }}
                            </text-regular>
                        </align-opposite>
                    </column>
                    <column>
                        <block :id="methodConfiguration.id"
                               stateId="stateId"
                               :show-arrow="methodConfiguration.settings.showArrow"
                               class="odr-waitlist-dialog__dropdown--disabled"
                               :value="methodConfiguration.value"
                               :values="methodConfiguration.options"
                               :type="methodConfiguration.type"
                               :title="methodConfiguration.title"
                               :settings="methodConfiguration.settings"
                               :suggest="methodConfiguration.settings.suggest"
                               :data-qa="methodConfiguration.dataQa"
                               @input="(value) => onMethodChanged(value)"/>
                    </column>
                </row>
            </gap>
            <gap top="double"
                 block="true"
                 v-if="showWeeklyTable">
                <gap v-for="item in weekdayItems"
                     :key="item.id"
                     block="true"
                     top="half">
                    <wrap
                        paddings="false"
                        borderRadius="half"
                        bordersVertical="true"
                        :borderColor="item.invalid ? 'error' : 'default'"
                        borders="true">
                        <div class="odr-waitlist-dialog__method-table-item">
                            <div class="odr-waitlist-dialog__checkbox-column">
                                <gap left="double">
                                    <checkbox
                                        :id="'checkbox.' + item.id"
                                        :value="item.isSelected"
                                        :title="item.label"
                                        @input="(value) => onTimeCheckboxChanged(value, item.id)"/>
                                </gap>
                            </div>
                            <div class="odr-waitlist-dialog__item-column">
                                <align-center>
                                    <gap top="single">
                                        <time-control
                                            :id="'from.' + item.id"
                                            :value="item.fromTime"
                                            :settings="timeSettings"
                                            @input="(value) => onFromTimeChanged(value, item.id)"/>
                                    </gap>
                                </align-center>
                            </div>
                            <div class="odr-waitlist-dialog__text-column">
                                <align-center textAlign="center">
                                    <gap top="single">
                                        to
                                    </gap>
                                </align-center>
                            </div>
                            <div class="odr-waitlist-dialog__item-column">
                                <align-center>
                                    <gap top="single">
                                        <time-control
                                            :id="'to.' + item.id"
                                            :value="item.toTime"
                                            :settings="timeSettings"
                                            @input="(value) => onToTimeChanged(value, item.id)"/>
                                    </gap>
                                </align-center>
                            </div>
                        </div>
                    </wrap>
                </gap>
            </gap>
            <gap block="true">
                <gap v-if="weekdayErrorMessages && weekdayErrorMessages.size > 0"
                     block="true"
                     top="half">
                    <align-opposite v-for="(error, index) in weekdayErrorMessages"
                                    :key="'validation_error'+ index">
                        <text-regular color="error">
                            {{ error }}
                        </text-regular>
                    </align-opposite>
                </gap>
            </gap>
            <gap top="double" block="true">
                <row table="true">
                    <column>
                        <align-opposite>
                            <text-regular bold="true">
                                {{ mobilePhoneConfiguration.title }}
                            </text-regular>
                        </align-opposite>
                    </column>
                    <column v-if="mobilePhoneConfiguration.settings.dropdown">
                        <block :id="mobilePhoneConfiguration.id"
                               stateId="stateId"
                               :class="{'odr-waitlist-dialog__dropdown--disabled__blur': this.disabledMobilePhone}"
                               :show-arrow="mobilePhoneConfiguration.settings.dropdown"
                               :value="mobilePhoneConfiguration.value"
                               :values="mobilePhoneConfiguration.options"
                               :type="mobilePhoneConfiguration.type"
                               :title="mobilePhoneConfiguration.placeholder"
                               :settings="mobilePhoneConfiguration.settings"
                               :suggest="mobilePhoneConfiguration.settings.suggest"
                               :data-qa="mobilePhoneConfiguration.dataQa"
                               @input="(value) => onPhoneNumberChanged(value)"/>

                    </column>
                    <column v-else class="odr-waitlist-dialog-col--input">
                        <block :id="mobilePhoneConfiguration.id"
                               stateId="stateId"
                               :value="mobilePhoneConfiguration.value"
                               :values="mobilePhoneConfiguration.values"
                               :type="mobilePhoneConfiguration.type"
                               :settings="mobilePhoneConfiguration.settings"
                               :data-qa="mobilePhoneConfiguration.dataQa"
                               @input="(value) => onPhoneNumberChanged(value)"/>
                    </column>
                </row>
                <row table="true">
                    <column/>
                    <column>
                        <div v-if="optionErrorMessages && optionErrorMessages.get(mobilePhoneConfiguration.id)"
                             :id="mobilePhoneConfiguration.id"
                             :data-qa="`${id}.error`"
                             class="odr-error-message"
                             :class="{
                                 'odr-error-message_plain': $root.appConfig.mode !== 'chat'
                             }">
                            {{ optionErrorMessages.get(mobilePhoneConfiguration.id) }}
                        </div>
                    </column>
                </row>
            </gap>
            <gap block="true">
                <row v-if="hasSavedWaitlist">
                    <column>
                        <align-center>
                            <div class="odr-block__wrap odr-block__wrap_with-bottom-space">
                                <main-button
                                    type="button"
                                    :data-qa="'remove.' +id"
                                    :data-qa-recorder="`remove-${id}`"
                                    @click="removeWaitlist">
                                    <text-regular color="plain" bold="true">
                                        {{ $trl('aw.remove_me') }}
                                    </text-regular>
                                </main-button>
                            </div>
                        </align-center>
                    </column>
                    <column>
                        <align-opposite>
                            <div class="odr-block__wrap odr-block__wrap_with-bottom-space">
                                <main-button
                                    type="button"
                                    :data-qa="'resubmit.' +id"
                                    :data-qa-recorder="`resubmit-${id}`"
                                    :style="`${disableResubmitButton ? 'background-color: #E1E1E1 !important;pointer-events: none !important;' : ''}`"
                                    @click="submitSetting">
                                    <text-regular color="plain" bold="true">
                                        {{ $trl('aw.resubmit') }}
                                    </text-regular>
                                    <icon half-width="true">keyboard_arrow_right</icon>
                                </main-button>
                            </div>
                        </align-opposite>
                    </column>
                </row>
                <row v-else>
                    <column>
                        <align-opposite>
                            <continue-button
                                :data-qa="'submit.' +id"
                                :data-qa-recorder="`submit-${id}`"
                                :submit="submitSetting">
                                {{ $trl('aw.submit') }}
                            </continue-button>
                        </align-opposite>
                    </column>
                </row>
            </gap>
        </gap>
    </form>
    <form v-else-if="showSuggestedSlot" class="odr-form" @submit="submitWaitlist">
        <gap all="double" block="true">
            <div v-if="suggestedSlots.length > 0">
                <gap all="double" block="true">
                    <gap block="true">
                        <row table="true">
                            <column>
                                <align-center textAlign="center">
                                    {{ $trl('aw.waitlist_suggested_description') }}
                                </align-center>
                            </column>
                        </row>
                    </gap>
                </gap>
                <br>
                <gap block="true"
                     top="single"
                     bottom="single">
                    <row>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--section">
                                {{ $trl('aw.waitlist_confirmation_method_section') }}
                            </div>
                        </column>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--value">
                                {{selectedMethodTitle}}
                            </div>
                        </column>
                        <column></column>
                    </row>
                    <div v-if="isWeeklyAvailabilityMethod">
                        <gap top="single"
                             bottom="single"
                             block="true"
                             v-for="day in weekdaySelected"
                             :key="day.id">
                            <row table="true">
                                <div class="odr-waitlist-dialog__day-column">
                                    <column>
                                        <align-opposite>
                                            <text-regular bold="true">
                                                {{day.fullDateOfWeek}}:
                                            </text-regular>
                                        </align-opposite>
                                    </column>
                                </div>
                                <div class="odr-waitlist-dialog__time-column">
                                    <column>
                                        <align-horizontal-center>
                                            <text-regular>
                                                {{day.fromTime}} to {{ day.toTime}}
                                            </text-regular>
                                        </align-horizontal-center>
                                    </column>
                                </div>
                            </row>
                        </gap>
                    </div>
                </gap>
                <br>
                <gap block="true"
                     top="single"
                     bottom="single">
                    <row>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--section">
                                {{ $trl('aw.waitlist_confirmation_slot_section') }}
                            </div>
                        </column>
                    </row>
                </gap>
                <gap top="single"
                     bottom="single"
                     block="true"
                     v-for="slotInfo in suggestedSlots"
                     :key="slotInfo.providerTitle">
                    <row>
                        <column>
                            <align-center textAlign="center">
                                <text-regular bold="true">
                                    {{slotInfo.providerTitle}}
                                </text-regular>
                            </align-center>
                        </column>
                    </row>
                    <row>
                        <column>
                            <align-center textAlign="center">
                                <div class="odr-waitlist-dialog__suggested-slot-info">
                                    {{slotInfo.slots}}
                                </div>
                            </align-center>
                        </column>
                    </row>
                    <row v-if="slotInfo.hasMore">
                        <column>
                            <align-center textAlign="center">
                                <text-regular>
                                    {{ $trl('aw.and_more') }}
                                </text-regular>
                            </align-center>
                        </column>
                    </row>
                </gap>
            </div>
            <div v-else>
                <gap all="double" block="true">
                    <gap block="true">
                        <row table="true">
                            <column>
                                <align-center textAlign="center">
                                    {{ $trl('aw.waitlist_confirm_message') }}
                                </align-center>
                            </column>
                        </row>
                    </gap>
                </gap>
                <br>
                <gap block="true"
                     top="single"
                     bottom="single">
                    <row>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--section">
                                {{ $trl('aw.waitlist_confirmation_method_section') }}
                            </div>
                        </column>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--value">
                                {{selectedMethodTitle}}
                            </div>
                        </column>
                        <column></column>
                    </row>
                </gap>
                <br>
                <div v-if="isWeeklyAvailabilityMethod">
                    <gap
                        top="single"
                        bottom="single"
                        block="true"
                        v-for="day in weekdaySelected"
                        :key="day.id">
                        <row table="true">
                            <div class="odr-waitlist-dialog__day-column">
                                <column>
                                    <align-opposite>
                                        <text-regular bold="true">
                                            {{day.fullDateOfWeek}}:
                                        </text-regular>
                                    </align-opposite>
                                </column>
                            </div>
                            <div class="odr-waitlist-dialog__time-column">
                                <column>
                                    <align-horizontal-center>
                                        <text-regular>
                                            {{day.fromTime}} to {{ day.toTime}}
                                        </text-regular>
                                    </align-horizontal-center>
                                </column>
                            </div>
                        </row>
                    </gap>
                </div>
            </div>
            <gap block="true" top="single">
                <row>
                    <column>
                        <align-center>
                            <back-button
                                color="plain"
                                :data-qa="'back.' +id"
                                :data-qa-recorder="`back-${id}`"
                                :submit="resetLayout">
                                {{ $trl('aw.back') }}
                            </back-button>
                        </align-center>
                    </column>
                    <column>
                        <align-opposite>
                            <continue-button
                                :data-qa="'submitWaitlist.' +id"
                                :data-qa-recorder="`submitWaitlist-${id}`"
                                :isDisableButton="disableSubmitButton"
                                :submit="submitWaitlist">
                                {{ $trl('aw.yes_submit') }}
                            </continue-button>
                        </align-opposite>
                    </column>
                </row>
            </gap>
        </gap>
    </form>
    <form v-else-if="showSubmissionMessage"  class="odr-form" @submit="onClose">
        <gap all="double" block="true">
            <br>
            <gap all="double" block="true">
                <gap block="true">
                    <row table="true">
                        <column>
                            <align-center textAlign="center">
                                {{submissionMessage}}
                            </align-center>
                        </column>
                    </row>
                </gap>
            </gap>
            <gap block="true">
                <row v-if="!hasSubmissionError">
                    <column>
                        <align-opposite>
                            <main-button
                                :data-qa="'close.' +id"
                                :data-qa-recorder="`close-${id}`"
                                @click="onClose">
                                {{ $trl('aw.close') }}
                            </main-button>
                        </align-opposite>
                    </column>
                </row>
                <row v-else>
                    <column>
                        <back-button
                            color="plain"
                            :data-qa="'back.' +id"
                            :data-qa-recorder="`back-${id}`"
                            :submit="resetLayout">
                            {{ $trl('aw.back') }}
                        </back-button>
                    </column>
                </row>
            </gap>
        </gap>
    </form>
</div>
<div v-else class="odr-waitlist-dialog odr-waitlist-dialog-mobile">
    <form v-if="showSetting" class="odr-form" @submit="submitSetting">
        <gap all="double" block="true">
            <gap all="double" block="true">
                <gap block="true">
                    <row table="true">
                        <column>
                            <align-center textAlign="center">
                                {{ $trl('aw.waitlist_description') }}
                            </align-center>
                        </column>
                    </row>
                    <br>
                    <row>
                        <column>
                            <align-center textAlign="center">
                                <text-regular bold="true">Note: </text-regular>
                                {{ $trl('aw.waitlist_note') }}
                            </align-center>
                        </column>
                    </row>
                </gap>
            </gap>
            <br>
            <gap top="double" block="true">
                <row table="true">
                    <column>
                        <block :id="providerConfiguration.id"
                               stateId="stateId"
                               :value="providerConfiguration.value"
                               :title="providerConfiguration.title"
                               :values="providerConfiguration.options"
                               :type="providerConfiguration.type"
                               :suggest="providerConfiguration.settings.suggest"
                               :data-qa="providerConfiguration.dataQa"
                               @input="(value) => onProviderChanged(value)"/>
                    </column>
                </row>
                <row table="true">
                    <column>
                        <div v-if="optionErrorMessages && optionErrorMessages.get(providerConfiguration.id)"
                             :id="providerConfiguration.id"
                             :data-qa="`${id}.error`"
                             class="odr-error-message"
                             :class="{
                                 'odr-error-message_plain': $root.appConfig.mode !== 'chat'
                             }">
                            {{ optionErrorMessages.get(providerConfiguration.id) }}
                        </div>
                    </column>
                </row>
            </gap>
            <gap top="double" block="true">
                <row table="true">
                    <column>
                        <block :id="methodConfiguration.id"
                               stateId="stateId"
                               :title="methodConfiguration.title"
                               :value="methodConfiguration.value[0]"
                               :values="methodConfiguration.options"
                               type="radio"
                               @input="(value) => onMethodChanged(value)"/>
                    </column>
                </row>
            </gap>
            <gap top="double"
                 block="true"
                 v-if="showWeeklyTable">
                <gap v-for="item in weekdayItems"
                     :key="item.id"
                     block="true"
                     top="half">
                    <wrap
                        paddings="false"
                        borderRadius="half"
                        bordersVertical="true"
                        :borderColor="item.invalid ? 'error' : 'default'"
                        borders="true">
                        <div class="odr-waitlist-dialog__method-table-item">
                            <div class="odr-waitlist-dialog__checkbox-column">
                                <gap left="double">
                                    <checkbox
                                        :id="'checkbox.' + item.id"
                                        :value="item.isSelected"
                                        :title="item.label"
                                        @input="(value) => onTimeCheckboxChanged(value, item.id)"/>
                                </gap>
                            </div>
                            <div class="odr-waitlist-dialog__item-column">
                                <align-center>
                                    <gap top="single">
                                        <time-control
                                            :id="'from.' + item.id"
                                            :value="item.fromTime"
                                            :settings="timeSettings"
                                            @input="(value) => onFromTimeChanged(value, item.id)"/>
                                    </gap>
                                </align-center>
                            </div>
                            <div class="odr-waitlist-dialog__text-column">
                                <align-center textAlign="center">
                                    <gap top="single">
                                        to
                                    </gap>
                                </align-center>
                            </div>
                            <div class="odr-waitlist-dialog__item-column">
                                <align-center>
                                    <gap top="single">
                                        <time-control
                                            :id="'to.' + item.id"
                                            :value="item.toTime"
                                            :settings="timeSettings"
                                            @input="(value) => onToTimeChanged(value, item.id)"/>
                                    </gap>
                                </align-center>
                            </div>
                        </div>
                    </wrap>
                </gap>
            </gap>
            <gap block="true">
                <gap v-if="weekdayErrorMessages && weekdayErrorMessages.size > 0"
                     block="true"
                     top="half">
                    <align-opposite v-for="(error, index) in weekdayErrorMessages"
                                    :key="'validation_error'+ index">
                        <text-regular color="error">
                            {{ error }}
                        </text-regular>
                    </align-opposite>
                </gap>
            </gap>
            <gap top="double" block="true">
                <row table="true">
                    <column v-if="mobilePhoneConfiguration.settings.dropdown">
                        <block :id="mobilePhoneConfiguration.id"
                               stateId="stateId"
                               :class="{'odr-waitlist-dialog__dropdown--disabled': this.disabledMobilePhone}"
                               :title="mobilePhoneConfiguration.title"
                               :value="mobilePhoneConfiguration.value"
                               :values="mobilePhoneConfiguration.options"
                               type="radio"
                               :data-qa="mobilePhoneConfiguration.dataQa"
                               @input="(value) => onPhoneNumberChanged(value)"/>

                    </column>
                    <column v-else>
                        <block :id="mobilePhoneConfiguration.id"
                               stateId="stateId"
                               :value="mobilePhoneConfiguration.value"
                               :values="mobilePhoneConfiguration.values"
                               :title="mobilePhoneConfiguration.title"
                               :type="mobilePhoneConfiguration.type"
                               :settings="mobilePhoneConfiguration.settings"
                               :data-qa="mobilePhoneConfiguration.dataQa"
                               @input="(value) => onPhoneNumberChanged(value)"/>
                    </column>
                </row>
                <row table="true">
                    <column>
                        <div v-if="optionErrorMessages && optionErrorMessages.get(mobilePhoneConfiguration.id)"
                             :id="mobilePhoneConfiguration.id"
                             :data-qa="`${id}.error`"
                             class="odr-error-message"
                             :class="{
                                 'odr-error-message_plain': $root.appConfig.mode !== 'chat'
                             }">
                            {{ optionErrorMessages.get(mobilePhoneConfiguration.id) }}
                        </div>
                    </column>
                </row>
            </gap>
            <gap block="true">
                <row v-if="hasSavedWaitlist">
                    <column>
                        <align-horizontal-center>
                            <div class="odr-block__wrap odr-block__wrap_with-bottom-space">
                                <main-button
                                    type="button"
                                    :data-qa="'remove.' +id"
                                    :data-qa-recorder="`remove-${id}`"
                                    @click="removeWaitlist">
                                    <text-regular color="plain" bold="true">
                                        {{ $trl('aw.remove_me') }}
                                    </text-regular>
                                </main-button>
                            </div>
                        </align-horizontal-center>
                    </column>
                    <column>
                        <align-opposite>
                            <div class="odr-block__wrap odr-block__wrap_with-bottom-space">
                                <main-button
                                    type="button"
                                    :data-qa="'resubmit.' +id"
                                    :data-qa-recorder="`resubmit-${id}`"
                                    :style="`${disableResubmitButton ? 'background-color: #E1E1E1 !important;pointer-events: none !important;' : ''}`"
                                    @click="submitSetting">
                                    <text-regular color="plain" bold="true">
                                        {{ $trl('aw.resubmit') }}
                                    </text-regular>
                                    <icon half-width="true">keyboard_arrow_right</icon>
                                </main-button>
                            </div>
                        </align-opposite>
                    </column>
                </row>
                <row v-else>
                    <column>
                        <align-opposite>
                            <continue-button
                                :data-qa="'submit.' +id"
                                :data-qa-recorder="`submit-${id}`"
                                :submit="submitSetting">
                                {{ $trl('aw.submit') }}
                            </continue-button>
                        </align-opposite>
                    </column>
                </row>
            </gap>
        </gap>
    </form>
    <form v-else-if="showSuggestedSlot" class="odr-form" @submit="submitWaitlist">
        <gap all="double" block="true">
            <div v-if="suggestedSlots.length > 0">
                <gap all="double" block="true">
                    <gap block="true">
                        <row table="true">
                            <column>
                                <align-center textAlign="center">
                                    {{ $trl('aw.waitlist_suggested_description') }}
                                </align-center>
                            </column>
                        </row>
                    </gap>
                </gap>
                <gap block="true"
                     top="single"
                     bottom="single">
                    <row>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--section">
                                {{ $trl('aw.waitlist_confirmation_method_section') }}
                            </div>
                        </column>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--value">
                                {{selectedMethodTitle}}
                            </div>
                        </column>
                        <column></column>
                    </row>
                    <div v-if="isWeeklyAvailabilityMethod">
                        <gap top="single"
                             bottom="single"
                             block="true"
                             v-for="day in weekdaySelected"
                             :key="day.id">
                            <row table="true">
                                <div class="odr-waitlist-dialog__day-column">
                                    <column>
                                        <align-opposite>
                                            <text-regular bold="true">
                                                {{day.fullDateOfWeek}}:
                                            </text-regular>
                                        </align-opposite>
                                    </column>
                                </div>
                                <div class="odr-waitlist-dialog__time-column">
                                    <column>
                                        <align-horizontal-center>
                                            <text-regular>
                                                {{day.fromTime}} to {{ day.toTime}}
                                            </text-regular>
                                        </align-horizontal-center>
                                    </column>
                                </div>
                            </row>
                        </gap>
                    </div>
                </gap>
                <br>
                <gap block="true"
                     top="single"
                     bottom="single">
                    <row>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--section">
                                {{ $trl('aw.waitlist_confirmation_slot_section') }}
                            </div>
                        </column>
                    </row>
                </gap>
                <gap top="single"
                     bottom="single"
                     block="true"
                     v-for="slotInfo in suggestedSlots"
                     :key="slotInfo.providerTitle">
                    <row>
                        <column>
                            <align-center textAlign="center">
                                <text-regular bold="true">
                                    {{slotInfo.providerTitle}}
                                </text-regular>
                            </align-center>
                        </column>
                    </row>
                    <row>
                        <column>
                            <align-center textAlign="center">
                                <div class="odr-waitlist-dialog__suggested-slot-info">
                                    {{slotInfo.slots}}
                                </div>
                            </align-center>
                        </column>
                    </row>
                    <row v-if="slotInfo.hasMore">
                        <column>
                            <align-center textAlign="center">
                                <text-regular>
                                    {{ $trl('aw.and_more') }}
                                </text-regular>
                            </align-center>
                        </column>
                    </row>
                </gap>
            </div>
            <div v-else>
                <gap all="double" block="true">
                    <gap block="true">
                        <row table="true">
                            <column>
                                <align-center textAlign="center">
                                    {{ $trl('aw.waitlist_confirm_message') }}
                                </align-center>
                            </column>
                        </row>
                    </gap>
                </gap>
                <br>
                <gap block="true"
                     top="single"
                     bottom="single">
                    <row>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--section">
                                {{ $trl('aw.waitlist_confirmation_method_section') }}
                            </div>
                        </column>
                        <column>
                            <div class="odr-waitlist-dialog-confirmation--value">
                                {{selectedMethodTitle}}
                            </div>
                        </column>
                        <column></column>
                    </row>
                </gap>
                <br>
                <div v-if="isWeeklyAvailabilityMethod">
                    <gap top="single"
                         bottom="single"
                         block="true"
                         v-for="day in weekdaySelected"
                         :key="day.id">
                        <row table="true">
                            <div class="odr-waitlist-dialog__day-column">
                                <column>
                                    <align-opposite>
                                        <text-regular bold="true">
                                            {{day.fullDateOfWeek}}:
                                        </text-regular>
                                    </align-opposite>
                                </column>
                            </div>
                            <div class="odr-waitlist-dialog__time-column">
                                <column>
                                    <align-horizontal-center>
                                        <text-regular>
                                            {{day.fromTime}} to {{ day.toTime}}
                                        </text-regular>
                                    </align-horizontal-center>
                                </column>
                            </div>
                        </row>
                    </gap>
                </div>
            </div>
            <gap block="true" top="single">
                <row>
                    <column>
                        <align-center>
                            <back-button
                                color="plain"
                                :data-qa="'back.' +id"
                                :data-qa-recorder="`back-${id}`"
                                :submit="resetLayout">
                                {{ $trl('aw.back') }}
                            </back-button>
                        </align-center>
                    </column>
                    <column>
                        <align-opposite>
                            <continue-button
                                :data-qa="'submitWaitlist.' +id"
                                :data-qa-recorder="`submitWaitlist-${id}`"
                                :isDisableButton="disableSubmitButton"
                                :submit="submitWaitlist">
                                {{ $trl('aw.yes_submit') }}
                            </continue-button>
                        </align-opposite>
                    </column>
                </row>
            </gap>
        </gap>
    </form>
    <form v-else-if="showSubmissionMessage"  class="odr-form" @submit="onClose">
        <gap all="double" block="true">
            <br>
            <gap all="double" block="true">
                <gap block="true">
                    <row table="true">
                        <column>
                            <align-center textAlign="center">
                                {{submissionMessage}}
                            </align-center>
                        </column>
                    </row>
                </gap>
            </gap>
            <gap block="true">
                <row v-if="!hasSubmissionError">
                    <column>
                        <align-opposite>
                            <main-button
                                :data-qa="'close.' +id"
                                :data-qa-recorder="`close-${id}`"
                                @click="onClose">
                                {{ $trl('aw.close') }}
                            </main-button>
                        </align-opposite>
                    </column>
                </row>
                <row v-else>
                    <column>
                        <back-button
                            color="plain"
                            :data-qa="'back.' +id"
                            :data-qa-recorder="`back-${id}`"
                            :submit="resetLayout">
                            {{ $trl('aw.back') }}
                        </back-button>
                    </column>
                </row>
            </gap>
        </gap>
    </form>
</div>
</template>

<script>
import '@/scss/blocks/waitlist-dialog.scss';
import { mapState } from 'vuex';
import { stickyRefresh } from '@/utils/sticky';
import { date2str, str2date, TIME_FORMAT } from '@/utils/format';
import { hideDropdown } from '@/utils/dropdown';
import { Waitlist, WaitlistBinding, WaitlistRange, WaitlistMethod } from '@/types/waitlist';
import {
    FIRST_AVAILABLE_ID,
    WEEKLY_AVAILABILITY_ID,
    getEarliestSlotsFromCards,
    parseListDateStrToStr,
    formatTimeWeekdayItems, formatPhoneNumber,
} from '@/utils/waitlist';
import { applyMask } from '@/utils/mask';
const DEFAULT_MASK = '(###)-###-####';
const SELECT_ALL_ID = 'selectAllId';
const SHORT_DATE_FORMAT = '#day:3';
const FULL_DATE_FORMAT = '#day';
const PROVIDER_ID = 'provider_id';
const METHOD_ID = 'method_id';
const NUMBER_SLOT_SUGGESTED = 3;
const NUMBER_PROVIDER_SUGGESTED = 3;
const NEW_WAITLIST_REASON = 'New Waitlist Registration';
export default {
    components: {
        'align-center': require('@clearwave/odoro-markup/lib/vue/align-center.vue').default,
        'align-opposite': require('@clearwave/odoro-markup/lib/vue/align-opposite.vue').default,
        'align-horizontal-center': require('@clearwave/odoro-markup/lib/vue/align-horizontal-center.vue').default,
        gap: require('@clearwave/odoro-markup/lib/vue/gap.vue').default,
        row: require('@clearwave/odoro-markup/lib/vue/row.vue').default,
        'text-regular': require('@clearwave/odoro-markup/lib/vue/text-regular.vue').default,
        wrap: require('@clearwave/odoro-markup/lib/vue/wrap.vue').default,
        column: require('@clearwave/odoro-markup/lib/vue/column.vue').default,
        block: require('@/vue/block.vue').default,
        'time-control': require('@/vue/blocks/time.vue').default,
        checkbox: require('@/vue/blocks/checkbox.vue').default,
        'continue-button': require('@/vue/continue').default,
        'main-button': require('@clearwave/odoro-markup/lib/vue/main-button.vue').default,
        'back-button': require('@/vue/back-button').default,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
    props: {
        width: {
            type: Number,
            default: 400,
        },
        providers: {
            type: Array,
            default: () => [],
        },
        id: {
            type: String,
            default: null,
        },
        dropdownId: {
            type: String,
            default: null,
        },
        submittedWaitlist: {
            type: Waitlist,
            default: null,
        },
        filteredCards: {
            type: Array,
            default: () => [],
        },
        waitlistSettings: {
            type: Object,
            default: () => {},
        },
    },
    data () {
        const submittedWaitlist = this.submittedWaitlist;
        const waitlistSettings = this.waitlistSettings || {};
        let selectedProviders = [];
        let selectedMobilePhone = (waitlistSettings.waitlistContactPhones && waitlistSettings.waitlistContactPhones.length === 1) ? waitlistSettings.waitlistContactPhones[0] : '';
        let selectedMethods = [FIRST_AVAILABLE_ID];
        const providers = this.providers;
        let showWeeklyTable = false;
        let savedRanges = [];
        let autoSelectProvider = false;
        if (submittedWaitlist) {
            const resourceIds = submittedWaitlist.bindings._resource || [];
            selectedProviders = resourceIds.filter(resourceId => providers.some(provider => provider.id === resourceId));
            if (submittedWaitlist.option.toUpperCase() === WaitlistMethod.WEEKLY_AVAILABILITY) {
                selectedMethods = [WEEKLY_AVAILABILITY_ID];
                showWeeklyTable = true;
                savedRanges = submittedWaitlist.ranges || [];
            }
            if (submittedWaitlist.consumerDetails.patientPhone) {
                selectedMobilePhone = submittedWaitlist.consumerDetails.patientPhone || '';
            }
        } else {
            if (providers.length === 1) {
                selectedProviders = [this.providers[0].id];
                autoSelectProvider = true;
            }
        }
        const weekdayItems = Array(7).fill(true)
            .map((_, index) => {
                const date = new Date(1970, 0, 4 + this.$root.appConfig.firstWeekDay + index);
                const fullDateOfWeek = date2str(date, FULL_DATE_FORMAT);
                const shortDateOfWeek = date2str(date, SHORT_DATE_FORMAT);
                const savedRange = savedRanges.find(range => range.dayOfWeek === fullDateOfWeek.toUpperCase());
                return {
                    fullDateOfWeek: this.$trl(fullDateOfWeek).toString(),
                    id: this.$root.appConfig.firstWeekDay + index,
                    label: shortDateOfWeek,
                    fromTime: savedRange ? savedRange.fromTime : null,
                    toTime: savedRange ? savedRange.toTime : null,
                    isSelected: !!savedRange,
                    invalid: false,
                };
            });
        return {
            selectedMethod: selectedMethods,
            weekdayItems,
            weekdayErrorMessages: null,
            optionErrorMessages: null,
            showSubmissionMessage: false,
            hasSubmissionError: false,
            showWeeklyTable,
            selectedProviders,
            selectedMobilePhone,
            disabledMobilePhone: !!selectedMobilePhone,
            hasSavedWaitlist: !!submittedWaitlist,
            submissionMessage: '',
            showSetting: true,
            showSuggestedSlot: false,
            disableResubmitButton: true,
            disableSubmitButton: false,
            autoSelectProvider,
            timeSettings: {
                start: this.$root.appConfig.defaultStartTime,
                end: this.$root.appConfig.defaultEndTime,
                dropdown: true,
                minuteStep: this.$root.appConfig.minuteStep,
                required: true,
            },
        };
    },
    watch: {
        selectedMethod: {
            deep: true,
            handler () {
                this.showWeeklyTable = this.selectedMethod.includes(WEEKLY_AVAILABILITY_ID);
            },
        },
        providers: {
            deep: true,
            handler () {
                const providers = this.providers;
                if (providers.length === 1) {
                    if (!this.hasSavedWaitlist) {
                        if (!this.selectedProviders.includes(providers[0].id)) {
                            this.autoSelectProvider = true;
                        }
                        this.selectedProviders = [providers[0].id];
                    } else {
                        const isContainProvider = this.selectedProviders.includes(providers[0].id);
                        this.selectedProviders = isContainProvider ? this.selectedProviders.filter(id => id === providers[0].id) : [];
                    }
                } else {
                    const providerIds = providers.map(item => item.id);
                    let filterSelectedProviders = this.selectedProviders.filter(id => providerIds.includes(id));
                    if (this.hasSavedWaitlist) {
                        const hasMatchWithAnyProvider = (this.submittedWaitlist.bindings._resource || []).some(id => providerIds.includes(id));
                        if (hasMatchWithAnyProvider) {
                            filterSelectedProviders = this.selectedProviders = this.submittedWaitlist.bindings._resource.filter(id => providerIds.includes(id));
                        }
                    }
                    this.selectedProviders = filterSelectedProviders;
                    if (this.selectedProviders.length === providers.length) {
                        this.selectedProviders.push(SELECT_ALL_ID);
                    }
                    if (this.autoSelectProvider) {
                        this.selectedProviders = [];
                        this.autoSelectProvider = false;
                    }
                }
                this.resetLayout();
            },
        },
    },
    computed: {
        ...mapState('dimensions', {
            dimensionsMode: 'mode',
        }),
        numberContactPhone () {
            const waitlistSettings = this.waitlistSettings || {};
            const waitlistContactPhones = waitlistSettings.waitlistContactPhones;
            if (waitlistContactPhones) {
                return waitlistContactPhones.length;
            }
            return 0;
        },
        providerOptions () {
            const selectAllOption = {
                title: this.$trl('aw.waitlist_select_provider'),
                selectAllOption: true,
                id: SELECT_ALL_ID,
                description: this.$trl('aw.select_all'),
            };
            return this.providers.length > 1 ? [selectAllOption, ...this.providers] : this.providers;
        },
        providerConfiguration () {
            return {
                id: PROVIDER_ID,
                value: this.selectedProviders,
                options: this.providerOptions,
                type: 'checkboxList',
                title: this.$trl('aw.waitlist_select_provider'),
                settings: {
                    dropdown: true,
                    suggest: this.providerOptions.length > this.$root.appConfig.providerListFilterSuggestMoreThan,
                },
            };
        },
        mobilePhoneConfiguration () {
            const waitlistSettings = this.waitlistSettings || {};
            const waitlistContactPhones = waitlistSettings.waitlistContactPhones;
            const mask = waitlistSettings.mask || DEFAULT_MASK;
            const hasMultiplePhone = waitlistContactPhones && waitlistContactPhones.length > 1;
            if (hasMultiplePhone) {
                const options = [];
                waitlistContactPhones.forEach(phone => {
                    options.push({
                        title: applyMask(formatPhoneNumber(phone), mask),
                        id: phone,
                    });
                });
                if (this.selectedMobilePhone && this.selectedMobilePhone.length > 0 && waitlistContactPhones.findIndex(phone => phone === this.selectedMobilePhone) === -1) {
                    const additionalOption = {
                        id: this.selectedMobilePhone,
                        title: applyMask(formatPhoneNumber(this.selectedMobilePhone), mask),
                    };
                    options.push(additionalOption);
                }

                return {
                    id: 'mobile_phone',
                    value: this.selectedMobilePhone || [],
                    options: options,
                    type: 'options',
                    mask,
                    title: this.$trl('aw.waitlist_mobile_phone_title'),
                    placeholder: this.$trl('aw.waitlist_mobile_phone_placeholder'),
                    settings: {
                        dropdown: true,
                        showArrow: !this.disabledMobilePhone,
                    },
                };
            }
            return {
                id: 'mobile_phone',
                value: this.disabledMobilePhone ? formatPhoneNumber(this.selectedMobilePhone) : this.selectedMobilePhone,
                type: 'input',
                mask,
                title: this.$trl('aw.waitlist_mobile_phone_title'),
                settings: {
                    mask: mask,
                    inputPattern: '\\d*',
                    disabled: this.disabledMobilePhone,
                    noBorderStyle: true,
                },
            };
        },
        methodConfiguration () {
            const methodOptions = [
                { title: this.$trl('aw.waitlist_first_available'), id: FIRST_AVAILABLE_ID },

                // Will be used in the future
                // { title: this.$trl('aw.waitlist_weekly_availability'), id: WEEKLY_AVAILABILITY_ID },
            ];
            return {
                id: METHOD_ID,
                value: this.selectedMethod,
                options: methodOptions,
                type: 'options',
                title: this.$trl('aw.waitlist_method'),
                settings: {
                    showArrow: false,
                    dropdown: true,
                    suggest: false,
                },
            };
        },
        waitlistPayload () {
            let selectedLocations = [];
            let selectedResources = [];
            this.selectedProviders.forEach(selectedProviderId => {
                if (selectedProviderId === SELECT_ALL_ID) {
                    return;
                }
                const details = this.providers.find(provider => provider.id === selectedProviderId);
                selectedLocations = selectedLocations.concat(details.location);
                selectedResources = selectedResources.concat(details.id);
            });
            const bindings = new WaitlistBinding({
                _location: selectedLocations,
                _resource: selectedResources,
            });
            const activeItems = this.weekdayItems.filter(item => item.isSelected);
            const ranges = activeItems.map(item => new WaitlistRange({
                dayOfWeek: item.fullDateOfWeek.toLocaleUpperCase(),
                fromTime: item.fromTime,
                toTime: item.toTime,
            }));
            const flowLastStep = this.$store.getters['flow/lastStep'];
            return new Waitlist({
                option: this.selectedMethod[0] === WEEKLY_AVAILABILITY_ID ? WaitlistMethod.WEEKLY_AVAILABILITY : WaitlistMethod.FIRST_AVAILABLE,
                bindings,
                clinicId: this.$root.appConfig.clinicId,
                stateId: flowLastStep.stateId,
                reason: NEW_WAITLIST_REASON,
                ranges: this.showWeeklyTable ? ranges : [],
                consumerDetails: {
                    patientPhone: this.selectedMobilePhone,
                },
            });
        },
        suggestedSlots () {
            const selectedProviders = this.selectedProviders.filter(id => id !== SELECT_ALL_ID) || [];
            const providers = this.providers;
            const selectedMethod = this.selectedMethod;
            const cards = this.filteredCards;
            let suggestedSlots = [];

            if (selectedMethod.length > 0) {
                selectedProviders.forEach((providerId) => {
                    if (suggestedSlots.length === NUMBER_PROVIDER_SUGGESTED) {
                        return;
                    }
                    const cardByProviders = cards.filter(item => item.filterProperties.resource.includes(providerId)) || [];
                    const slots = getEarliestSlotsFromCards(cardByProviders, selectedMethod[0], this.weekdayItems);
                    const provider = providers.find(item => item.id === providerId);
                    if (slots && slots.length > 0) {
                        const filteredSlots = [];
                        slots.forEach(slot => {
                            if (filteredSlots.length < NUMBER_SLOT_SUGGESTED) {
                                filteredSlots.push(slot.datetime);
                            }
                        });
                        suggestedSlots.push({
                            providerTitle: provider.title,
                            slots: parseListDateStrToStr(filteredSlots, !this.$root.appConfig.ampm),
                            hasMore: filteredSlots.length === NUMBER_SLOT_SUGGESTED && slots.length > NUMBER_SLOT_SUGGESTED,
                        });
                    }
                });
            }
            return suggestedSlots;
        },
        weekdaySelected () {
            const weekDaySelected = this.weekdayItems.filter(item => item.isSelected) || [];
            return formatTimeWeekdayItems(weekDaySelected, !this.$root.appConfig.ampm);
        },
        selectedMethodTitle () {
            return this.selectedMethod[0] === FIRST_AVAILABLE_ID ? this.$trl('aw.waitlist_first_available') : this.$trl('aw.waitlist_weekly_availability');
        },
        isWeeklyAvailabilityMethod () {
            return this.selectedMethod[0] === WEEKLY_AVAILABILITY_ID;
        },
    },
    methods: {
        resetLayout () {
            this.showSetting = true;
            this.showSuggestedSlot = false;
            this.showSubmissionMessage = false;
        },
        resetSelected () {
            this.selectedProviders = [];
            this.selectedMethod = [FIRST_AVAILABLE_ID];
            this.weekdayItems.forEach(item => {
                item.invalid = false;
                item.fromTime = null;
                item.toTime = null;
                item.isSelected = false;
            });
            this.selectedMobilePhone = [];

            // case is not multiple phone contact
            if (this.numberContactPhone <= 1) {
                const waitlistSettings = this.waitlistSettings || {};
                const phoneNumbers = waitlistSettings.waitlistContactPhones || [];
                this.selectedMobilePhone = phoneNumbers[0] || '';
            }

            this.optionErrorMessages = null;
            this.weekdayErrorMessages = null;
        },
        submitSetting () {
            const checkMobilePhoneNumber = (phoneNumber, mask) => {
                if (!phoneNumber || phoneNumber.length === 0) {
                    return {
                        error: true,
                        message: this.$trl('aw.required_field'),
                    };
                }
                const maskCount = mask.split('').filter(char => char === '#').length;
                const digitsOnly = phoneNumber.replace(/\D/g, '');
                return {
                    error: digitsOnly.length !== maskCount,
                    message: this.$trl('aw.phone_number_invalid'),
                };
            };
            const validationOption = () => {
                const errors = new Map();
                Array.of(this.providerConfiguration, this.methodConfiguration).forEach((option) => {
                    if (option.value.length === 0) {
                        errors.set(option.id, this.$trl('aw.required_field'));
                    } else {
                        errors.delete(option.id);
                    }
                });
                const mobileConfig = this.mobilePhoneConfiguration;
                const validationPhoneNumber = checkMobilePhoneNumber(mobileConfig.value, mobileConfig.mask);
                if (!this.disabledMobilePhone && validationPhoneNumber.error) {
                    errors.set(this.mobilePhoneConfiguration.id, validationPhoneNumber.message);
                }
                return errors;
            };
            const validationWeekDay = () => {
                let errors = new Set();
                if (this.showWeeklyTable) {
                    const hasSelect = this.weekdayItems.some((record) => record.isSelected);
                    if (!hasSelect) {
                        errors.add(this.$trl('aw.waitlist_weekday_required'));
                    } else {
                        this.weekdayItems.forEach((record) => {
                            record.invalid = false;
                            if (record.isSelected) {
                                const from = record.fromTime ? str2date(record.fromTime, TIME_FORMAT) : null;
                                const to = record.toTime ? str2date(record.toTime, TIME_FORMAT) : null;
                                if (!from) {
                                    errors.add(this.$trl('aw.waitlist_from_time_invalid'));
                                    record.invalid = true;
                                }
                                if (!to) {
                                    errors.add(this.$trl('aw.waitlist_to_time_invalid'));
                                    record.invalid = true;
                                }
                                if (from && to && !(from.getTime() < to.getTime())) {
                                    errors.add(this.$trl('aw.waitlist_time_range_invalid'));
                                    record.invalid = true;
                                }
                            }
                        });
                    }
                }
                return errors;
            };

            this.optionErrorMessages = validationOption();

            this.weekdayErrorMessages = validationWeekDay();

            if (this.weekdayErrorMessages.size === 0 && this.optionErrorMessages.size === 0) {
                this.showSetting = false;
                this.showSuggestedSlot = true;
            }
        },
        onClose () {
            this.submissionMessage = null;
            this.resetLayout();
            hideDropdown(this.dropdownId);
        },
        submitWaitlist () {
            this.disableSubmitButton = true;
            const onSubmitted = (status) => {
                this.submissionMessage = this.$store.state.waitlist.message;
                this.hasSubmissionError = !status;
                this.showSubmissionMessage = true;
                this.showSuggestedSlot = false;
                this.hasSavedWaitlist = status;
                this.disableResubmitButton = status;
                this.disableSubmitButton = !status;
                if (status) {
                    this.disabledMobilePhone = true;
                    this.submittedWaitlist = this.$store.state.waitlist.data;
                    this.$emit('onRetrievedWaitlist', true);
                    this.$store.commit('flow/SET_WAITLIST', { waitlist: this.$store.state.waitlist.data });
                }
            };
            this.$store.dispatch('waitlist/SUBMIT_WAITLIST', {
                data: this.waitlistPayload,
                appConfig: this.$root.appConfig,
                callback: onSubmitted,
            });
        },
        onMethodChanged (value) {
            this.selectedMethod = [...value];
            this.disableResubmitButton = false;
        },
        onProviderChanged (value) {
            this.optionErrorMessages = null;
            this.disableResubmitButton = false;
            this.selectedProviders = [...value];
        },
        onPhoneNumberChanged (value) {
            this.optionErrorMessages = null;
            this.disableResubmitButton = false;
            this.selectedMobilePhone = value;
        },
        onTimeCheckboxChanged  (value, id) {
            this.resetWeekDayValidation();
            const rowToBeChanged = this.weekdayItems.find((record) => record.id === id);
            if (rowToBeChanged) {
                rowToBeChanged.isSelected = value;
                if (!rowToBeChanged.isSelected) {
                    rowToBeChanged.fromTime = null;
                    rowToBeChanged.toTime = null;
                }
            }
        },
        onFromTimeChanged (value, id) {
            this.resetWeekDayValidation();
            const rowToBeChanged = this.weekdayItems.find((record) => record.id === id);
            if (rowToBeChanged) {
                rowToBeChanged.fromTime = value;
                if (rowToBeChanged.toTime || rowToBeChanged.fromTime) {
                    rowToBeChanged.isSelected = true;
                }
            }
        },
        onToTimeChanged (value, id) {
            this.resetWeekDayValidation();
            const rowToBeChanged = this.weekdayItems.find((record) => record.id === id);
            if (rowToBeChanged) {
                rowToBeChanged.toTime = value;
                if (rowToBeChanged.toTime || rowToBeChanged.fromTime) {
                    rowToBeChanged.isSelected = true;
                }
            }
        },
        resetWeekDayValidation () {
            this.weekdayErrorMessages = null;
            this.disableResubmitButton = false;
            this.weekdayItems.forEach(item => {
                item.invalid = false;
            });
        },
        resetDisableMobilePhone () {
            // 1. case has multiple phone contact
            // 2. case don't have any phone contact
            if (this.numberContactPhone !== 1) {
                this.disabledMobilePhone = false;
            }
        },
        removeWaitlist () {
            const onDeleted = (status) => {
                this.hasSubmissionError = !status;
                this.hasSavedWaitlist = !status;
                this.disableResubmitButton = !status;
                if (status) {
                    this.onClose();
                    this.resetSelected();
                    this.resetDisableMobilePhone();
                    this.$emit('onRetrievedWaitlist', false);
                    this.$store.commit('flow/SET_WAITLIST', { waitlist: null });
                }
            };
            const flowLastStep = this.$store.getters['flow/lastStep'];
            const payload = this.submittedWaitlist;
            payload.stateId = flowLastStep.stateId;
            this.$store.dispatch('waitlist/DELETE_WAITLIST', {
                data: payload,
                appConfig: this.$root.appConfig,
                callback: onDeleted,
            });
        },
    },
};
</script>
